import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "validate-form-container" }

import { emitter } from '@/utils/eventBus';
import { onUnmounted } from 'vue';
type ValidateFunc = () => boolean

// 准备一个储存验证

const __default__ = {
  name:'CForm'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

let funcArr: ValidateFunc[] = []

//验证函数
const submitForm = () => {
  // 先通过 map 调用函数数组funcArr中的每一个函数，并把每个函数的结果（都是boolean类型）存入 result 数组
  // 然后再对装满了 boolean类型的数组 result 调用every方法，就知道表单是否都通过了
  const result = funcArr.map(func => func()).every(res => res)
  // return result
  //通过回调验证后发送请求
  // callback && callback(result)
  return Promise.resolve(result)
};
// 全局事件总线 form-item-cerated 的回调函数
const callback = (func: ValidateFunc) => {
  // console.log('form-item-cerated的回调执行了');
  // 将接收到的函数都推入funcArr 数组中
  funcArr.push(func)
}
emitter.on('formItemCreated', callback)

onUnmounted(() => {
  emitter.off('formItemCreated', callback);
  funcArr = []
});
//暴露验证方法
__expose({
  submitForm
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})